import PropTypes from "prop-types"
import React, { useEffect, useRef, useState } from "react"

// //Import Scrollbar
import SimpleBar from "simplebar-react"

// MetisMenu
import MetisMenu from "metismenujs"
import { withRouter } from "react-router-dom"
import { Link } from "react-router-dom"
import { ADMIN, BRANCH_OWNER } from "../../constants/roles"

//i18n
import { withTranslation } from "react-i18next"
import { getDecodedFromBackend } from "common/helper"
import axios from "axios"

const SidebarContent = props => {
  const ref = useRef()
  // Use ComponentDidMount and ComponentDidUpdate method symultaniously
  useEffect(() => {
    const pathName = props.location.pathname

    const initMenu = () => {
      new MetisMenu("#side-menu")
      let matchingMenuItem = null
      const ul = document.getElementById("side-menu")
      const items = ul.getElementsByTagName("a")
      for (let i = 0; i < items.length; ++i) {
        if (pathName === items[i].pathname) {
          matchingMenuItem = items[i]
          break
        }
      }
      if (matchingMenuItem) {
        activateParentDropdown(matchingMenuItem)
      }
    }
    initMenu()
  }, [props.location.pathname])

  useEffect(() => {
    ref.current.recalculate()
  })

  function scrollElement(item) {
    if (item) {
      const currentPosition = item.offsetTop
      if (currentPosition > window.innerHeight) {
        ref.current.getScrollElement().scrollTop = currentPosition - 300
      }
    }
  }

  function activateParentDropdown(item) {
    item.classList.add("active")
    const parent = item.parentElement
    const parent2El = parent.childNodes[1]
    if (parent2El && parent2El.id !== "side-menu") {
      parent2El.classList.add("mm-show")
    }

    if (parent) {
      parent.classList.add("mm-active")
      const parent2 = parent.parentElement

      if (parent2) {
        parent2.classList.add("mm-show") // ul tag

        const parent3 = parent2.parentElement // li tag

        if (parent3) {
          parent3.classList.add("mm-active") // li
          parent3.childNodes[0].classList.add("mm-active") //a
          const parent4 = parent3.parentElement // ul
          if (parent4) {
            parent4.classList.add("mm-show") // ul
            const parent5 = parent4.parentElement
            if (parent5) {
              parent5.classList.add("mm-show") // li
              parent5.childNodes[0].classList.add("mm-active") // a tag
            }
          }
        }
      }
      scrollElement(item)
      return false
    }
    scrollElement(item)
    return false
  }

  const [permissions, setPermissions] = useState([]);
  const [role, setRole] = useState("");

  // Check if sub-admin has view access to a module (ModulePermission[] format)
  const can = (module) => {
    if (!Array.isArray(permissions)) return false;
    const entry = permissions.find(p => p?.module === module);
    return entry ? entry.view === true : false;
  };
  // Auto-open the Product Attributes submenu when navigating into any /admin/masters/* route
  const [mastersOpen, setMastersOpen] = useState(
    typeof props.location?.pathname === "string" &&
      props.location.pathname.startsWith("/admin/masters")
  );

  // Keep submenu open when user is on a masters page (e.g. after page reload)
  useEffect(() => {
    if (props.location?.pathname?.startsWith("/admin/masters")) {
      setMastersOpen(true);
    }
  }, [props.location?.pathname]);

  useEffect(() => {
    setPermissions(getDecodedFromBackend(localStorage.getItem("permissions")));
    setRole(getDecodedFromBackend(localStorage.getItem("role")));
  }, []);

  return (
    <React.Fragment>
      <SimpleBar className="h-100" ref={ref}>
        <div id="sidebar-menu">
          <ul className="metismenu list-unstyled mt-4" id="side-menu">

            {/* Dashboard */}
            <li className="menu-title">
              <i className="mdi mdi-arrow-right-drop-circle-outline font-size-12"></i>{" "}
              {props.t("Dashboard")}{" "}
            </li>
            <li>
              <Link to="/admin/dashboard">
                <i className="bx bx-home-circle"></i>
                <span>{props.t("Dashboard")}</span>
              </Link>
            </li>

            {
              role === BRANCH_OWNER && (
                <>
                  <li className="menu-title">
                    <i className="mdi mdi-arrow-right-drop-circle-outline font-size-12"></i>{" "}
                    {props.t("Management")}
                  </li>

                  <li>
                    <Link to="/admin/orders">
                      <i className="bx bx-customize"></i>
                      <span>{props.t("Orders")}</span>
                    </Link>
                  </li>
                </>
              )
            }

            {/* Management Section */}
            {(role === ADMIN || can("users_management") || can("branch_management") || can("product_management") || can("news_management") || can("transactions")) && (
              <>
                <li className="menu-title">
                  <i className="mdi mdi-arrow-right-drop-circle-outline font-size-12"></i>{" "}
                  {props.t("Management")}
                </li>

                {(role === ADMIN || can("users_management")) && (
                  <li>
                    <Link to="/admin/users">
                      <i className="bx bx-customize"></i>
                      <span>{props.t("Users")}</span>
                    </Link>
                  </li>
                )}

                {(role === ADMIN || can("branch_management")) && (
                  <li>
                    <Link to="/admin/branches">
                      <i className="bx bx-store"></i>
                      <span>{props.t("Branches")}</span>
                    </Link>
                  </li>
                )}

                {(role === ADMIN || can("product_management")) && (
                  <li>
                    <Link to="/admin/products">
                      <i className="bx bx-package"></i>
                      <span>{props.t("Products")}</span>
                    </Link>
                  </li>
                )}

                {(role === ADMIN || can("product_management")) && (
                  <li>
                    <a
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        setMastersOpen((v) => !v);
                      }}
                      style={{ cursor: "pointer" }}
                    >
                      <i className="bx bx-list-ul"></i>
                      <span>{props.t("Product Attributes")}</span>
                      <i
                        className={`bx bx-chevron-${mastersOpen ? "up" : "down"}`}
                        style={{ float: "right", marginTop: 4 }}
                      ></i>
                    </a>
                    {mastersOpen && (
                      <ul className="sub-menu" style={{ display: "block" }}>
                        <li><Link to="/admin/masters/metals">{props.t("Metal")}</Link></li>
                        <li><Link to="/admin/masters/karats">{props.t("Karat")}</Link></li>
                        <li><Link to="/admin/masters/purities">{props.t("Purity")}</Link></li>
                        <li><Link to="/admin/masters/types">{props.t("Type")}</Link></li>
                        <li><Link to="/admin/masters/brands">{props.t("Brand")}</Link></li>
                        <li><Link to="/admin/masters/categories">{props.t("Category")}</Link></li>
                        <li><Link to="/admin/masters/subcategories">{props.t("Subcategory")}</Link></li>
                        <li><Link to="/admin/masters/denominations">{props.t("Denomination")}</Link></li>
                        <li><Link to="/admin/masters/weights">{props.t("Weight")}</Link></li>
                        <li><Link to="/admin/masters/vendors">{props.t("Vendor")}</Link></li>
                        <li><Link to="/admin/masters/countries">{props.t("Country")}</Link></li>
                      </ul>
                    )}
                  </li>
                )}

                {(role === ADMIN || can("news_management")) && (
                  <li>
                    <Link to="/admin/news">
                      <i className="bx bxs-news"></i>
                      <span>{props.t("News")}</span>
                    </Link>
                  </li>
                )}

                {(role === ADMIN || can("transactions")) && (
                  <li>
                    <Link to="/admin/transactions">
                      <i className="bx bx-transfer"></i>
                      <span>{props.t("Transactions")}</span>
                    </Link>
                  </li>
                )}
                {role === ADMIN && (
                  <li>
                    <Link to="/admin/gifts">
                      <i className="bx bx-gift"></i>
                      <span>{props.t("Gifts")}</span>
                    </Link>
                  </li>
                )}
                {role === ADMIN && (
                  <li>
                    <Link to="/admin/withdrawal-requests">
                      <i className="bx bxs-receipt"></i>
                      <span>{props.t("Withdrawal Requests")}</span>
                    </Link>
                  </li>
                )}

                {role === ADMIN && (
                  <li>
                    <Link to="/admin/deposit-requests">
                      <i className="bx bx-receipt"></i>
                      <span>{props.t("Deposit Requests")}</span>
                    </Link>
                  </li>
                )}

                {role === ADMIN && (
                  <li>
                    <Link to="/admin/banks">
                      <i className="bx bxs-bank"></i>
                      <span>{props.t("Banks")}</span>
                    </Link>
                  </li>
                )}

                {role === ADMIN && (
                  <li>
                    <Link to="/admin/payout-banks">
                      <i className="bx bx-credit-card"></i>
                      <span>{props.t("Payout Banks")}</span>
                    </Link>
                  </li>
                )}

                {role === ADMIN && (
                  <li>
                    <Link to="/admin/group-markup">
                      <i className="bx bxs-group"></i>
                      <span>{props.t("Group Markup")}</span>
                    </Link>
                  </li>
                )}
              </>
            )}

            {/* Admin Management (Always Visible) */}
            {
              (role === ADMIN) && (
                <>
                  <li className="menu-title">
                    <i className="mdi mdi-arrow-right-drop-circle-outline font-size-12"></i>{" "}
                    {props.t("Admin Management")}
                  </li>
                  <li>
                    <Link to="/admin/sub-admin">
                      <i className="bx bxs-user-detail"></i>
                      <span>{props.t("Sub-Admin")}</span>
                    </Link>
                  </li>
                  <li>
                    <Link to="/admin/branch-owners">
                      <i className="bx bxs-bank"></i>
                      <span>{props.t("Branch Owners")}</span>
                    </Link>
                  </li>
                </>
              )
            }

            {/* Support Section */}
            {(role === ADMIN || can("support_feedback")) && (
              <>
                <li className="menu-title">
                  <i className="mdi mdi-arrow-right-drop-circle-outline font-size-12"></i>{" "}
                  {props.t("Support")}
                </li>
                <li>
                  <Link to="/admin/support-feedback">
                    <i className="bx bx-support"></i>
                    <span>{props.t("Support & Feedback")}</span>
                  </Link>
                </li>
              </>
            )}

            {(role === ADMIN || can("customization") || can("content_management") || can("faq_management")) && (
              <>
                <li className="menu-title">
                  <i className="mdi mdi-arrow-right-drop-circle-outline font-size-12"></i>{" "}
                  {props.t("Settings")}
                </li>

                {role === ADMIN ? (
                  <li>
                    <Link to="/admin/referral-bonus">
                      <i className="bx bx-customize"></i>
                      <span>{props.t("Referral Bonus")}</span>
                    </Link>
                  </li>
                ) : null}

                {(role === ADMIN || can("customization")) ? (
                  <li>
                    <Link to="/admin/customization">
                      <i className="bx bx-customize"></i>
                      <span>{props.t("Customization")}</span>
                    </Link>
                  </li>
                ) : null}

                {(role === ADMIN || can("content_management")) ? (
                  <li>
                    <Link to="/admin/cms">
                      <i className="bx bx-file"></i>
                      <span>{props.t("Content Management")}</span>
                    </Link>
                  </li>
                ) : null}

                {(role === ADMIN || can("faq_management")) ? (
                  <li>
                    <Link to="/admin/faq">
                      <i className="bx bx-help-circle"></i>
                      <span>{props.t("FAQ")}</span>
                    </Link>
                  </li>
                ) : null}
              </>
            )}


          </ul>

        </div>
      </SimpleBar>
    </React.Fragment>
  )
}

SidebarContent.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
}

export default withRouter(withTranslation()(SidebarContent))
